import classNames from 'classnames'
import { JSX } from 'react'

import { InventoryCard, InventoryType } from '@store'

import { InventoryCardItem } from '../card-item'
import styles from './InventoryGrid.module.scss'

interface InventoryGridProps {
  onClick(card: InventoryCard): void
  items: InventoryCard[]
  type: InventoryType
}

function generateEmptyCards(amount: number) {
  return [...Array(amount).keys()].map((item, i) => ({
    id: `empty-${i}`,
    type: 'empty',
  })) as InventoryCard[]
}

export const InventoryGrid = ({
  type,
  items,
  onClick,
}: InventoryGridProps): JSX.Element => {
  const cardsToRender =
    items.length >= 12
      ? items
      : [...items, ...generateEmptyCards(12 - items.length)]

  return (
    <div className={classNames(styles.inventoryGrid)}>
      <div className={styles.grid}>
        {cardsToRender.map((item) => (
          <InventoryCardItem type={type} key={item.id} card={item} onClick={onClick} />
        ))}
      </div>
    </div>
  )
}
